import {Base64ImageType, Stamp} from '@core/api/data-access';
import {StoredFile} from '@global-data';

export class ActiveUserStampViewModel extends Stamp {
	storedFileImage: StoredFile;
	isFixed: boolean;
	icon: string;

	constructor(stamp: Partial<ActiveUserStampViewModel>) {
		super(stamp);
		if (stamp.isFixed === true) {
			this.isFixed = true; // If isFixed is explicitly set to true, use that value
			this.icon = stamp.icon || ''; // Use provided icon or default to empty string
		} else {
			this.storedFileImage = new StoredFile(stamp.image, stamp.imageType);
			this.isFixed = false; // Default value, can be set based on specific logic
			this.icon = ''; // Default value, can be set based on specific logic
		}
		if (stamp.index !== undefined) {
			this.index = stamp.index; // Ensure index is set if available
		}
		// Additional initialization logic can go here if needed
	}

	toJSON(): Stamp {
		return {
			image: this.storedFileImage.fileEncode,
			imageType: this.storedFileImage.type as Base64ImageType,
			name: this.name,
		};
	}
}
